import React from 'react';
import styled from 'styled-components';
import { BlueButton } from '../../StyledComponents';
import FirstNameIcon from '../../../assets/formComponents/FirstNameIcon.svg';
import EmailIcon from '../../../assets/formComponents/emailIcon.svg';
import CompanyIcon from '../../../assets/formComponents/companyIcon.svg';
import DeviceNumberIcon from '../../../assets/formComponents/device.svg';
import { CountrySelect } from '@atlaskit/select';
// import PhoneIcon from '../../../assets/formComponents/phone.svg';
import {
  StyledInputs,
  PasswordMatchError,
} from '../../HomePage/EsperSignUpFormComponent';
import Axios from 'axios';
import { navigate, Link } from 'gatsby';
import { validatePhone } from '../../../globalFunctions';
import apiHost from '../../../apiHost';
import Checkbox from '../../UIComponents/Checkbox';
import Fade from 'react-reveal/Fade';
import { getCountryLink } from '../../../helpers/country';
import { getLanguageFromPath } from '../../../helpers';

export const RequestDemoFormComponent = styled.div`
  font-size: 14px;
  text-align: center;
  position: absolute;
  right: 0rem;
  top: 3rem;
  /* width: fit-content; */
  padding-right: 18rem;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-right: 14rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-right: 5rem;
  }
  @media (max-width: 1000px) {
    position: relative;
    top: unset;
    right: unset;
    padding: 0rem;
    width: 90%;
    max-width: 450px;
    margin: auto;
    margin-top: -2rem;
  }
`;

const PhoneInput = styled.div`
  grid-column: span 1;
  margin-top: -6px;
  width: calc(100% + 2.5rem);
  margin-left: -2.5rem;
  @media (max-width: 768px) {
    margin-left: 15px;
    width: unset;
  }
`;

export const RequestDemoFormContainer = styled.div`
  border-radius: 4px;
  padding-left: 3rem;
  padding-right: 3rem;
  width: min-content;
  box-shadow: 0 2px 21px 0 rgba(41, 35, 58, 0.12);
  background-color: #ffffff;
  display: grid;
  /* justify-items: center; */
  padding-top: 2rem;
  padding-bottom: 2rem;
  @media (max-width: 520px) {
    width: 100%;
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

const RequestDemoTitle = styled.h1`
  font-size: 28px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
`;

const BlueButtonNew = styled(BlueButton)`
  margin-top: 10px;
  min-width: 18rem;
  @media (min-width: 1280px) {
    min-width: 350px;
  }
  @media (min-width: 780px) and (max-width: 960px) {
    min-width: 350px;
  }
  @media (max-width: 400px) {
    min-width: 250px;
  }
`;

export default class RequestDemoForm extends React.Component<any, any> {
  state = {
    name: '',
    email: '',
    company: '',
    date: new Date(),
    deviceNumber: '',
    contactFocus: false,
    nameError: false,
    emailError: false,
    companyError: false,
    deviceNumberError: false,
    preferredDateError: false,
    submitError: false,
    loaded: false,
    contactNumber: '',
    defaultCountry: undefined,
    contactError: false,
    contactErrorMessage: '',
    langKey: 'en',
    countryError: false,
    consentCheckbox: false,
    consentError: false,
  };

  isAllValid = () =>
    !(this.state.companyError ||
    this.state.contactError ||
    this.state.nameError ||
    // this.state.preferredDateError ||
    this.state.deviceNumberError ||
    this.state.emailError ||
    this.state.consentError ||
    this.state.countryError ||
    this.props.messages.locale !== 'en'
      ? !this.state.consentCheckbox
      : false);

  validateAll = () => {
    this.validateCompany();
    this.validateDeviceNumber();
    this.validateContact();
    this.validateFullName();
    this.validateCountry();
    this.validateEmail();
    if (!this.state.consentCheckbox && this.props.messages.locale !== 'en') {
      this.setState({
        consentError: true,
      });
    }
  };

  validateCountry = () => {
    if (this.state.defaultCountry === undefined) {
      this.setState({
        countryError: true,
      });
    } else {
      this.setState({
        countryError: false,
      });
    }
  };

  componentDidMount() {
    this.setState({
      loaded: true,
      langKey: getLanguageFromPath(window.location.pathname)
        ? getLanguageFromPath(window.location.pathname)
        : 'en',
    });
  }

  navigateThankyou = () => {
    localStorage.setItem('prevPage', 'book-demo');
    navigate(
      this.props.messages.locale !== 'en'
        ? `/${this.props.messages.locale}/book-demo/submitted`
        : '/book-demo/submitted'
    );
    navigate(
      `${getCountryLink(this.state.defaultCountry?.abbr)}/?name=${
        this.state.name
      }&email=${this.state.email}&a2=${this.state.company}&a3=${
        this.state.defaultCountry?.name
      }&a4=${this.state.contactNumber}&a5=${this.state.deviceNumber}`
    );
  };

  getCookieValue = (name: string) => {
    const found = document.cookie
      .split(';')
      .filter((c) => c.trim().split('=')[0] === name);
    return found.length > 0 ? found[0].split('=')[1] : undefined;
  };

  sendData = () => {
    this.validateAll();
    if (this.isAllValid()) {
      localStorage.setItem('customerName', `${this.state.name}`);
      // localStorage.setItem('demoTime', `${this.state.date.toISOString()}`);
      const hubspotToken = this.getCookieValue('hubspotutk');
      Axios({
        url:
          'https://api.hsforms.com/submissions/v3/integration/submit/5868902/5768e2d9-8d0c-45df-a314-28a323e59298',
        method: 'POST',
        data: {
          fields: [
            {
              name: 'email',
              value: this.state.email,
            },
            {
              name: 'number_of_device',
              value: this.state.deviceNumber,
            },
            {
              name: 'firstname',
              value: this.state.name,
            },
            {
              name: 'phone',
              value: this.state.contactNumber,
            },
            {
              name: 'company',
              value: this.state.company,
            },
            {
              name: 'country',
              value: this.state.defaultCountry?.name ?? '',
            },
            // {
            //   name: 'demo_date',
            //   value: this.state.date,
            // },
            {
              name: 'language_key',
              value: this.state.langKey,
            },
          ],
          context: {
            hutk: hubspotToken,
            pageUri: window.location.href,
            pageName: document.title,
          },
        },
      })
        .then((response: any) => {
          this.navigateThankyou();
          this.setState({
            companyError: false,
            contactError: false,
            nameError: false,
            emailError: false,
            deviceNumberError: false,
            // preferredDateError: false,
            email: '',
            name: '',
            company: '',
            contactNumber: '',
            date: '',
            deviceNumber: '',
          });
        })
        .catch((error: any) => {
          if (error?.response?.data?.errors) {
            error.response.data.errors.forEach((item: any) => {
              if (item.message.includes('fields.number_of_device')) {
                this.setState({ deviceNumberError: true });
              } else if (item.message.includes('fields.email')) {
                this.setState({ emailError: true });
              } else if (item.message.includes('fields.phone')) {
                this.setState({ contactError: true });
              } else {
                console.log('error');
              }
            });
          }
        });
    } else {
      Axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          page: `Request Demo Form`,
          failure: true,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
    }
  };

  // VALIDATIONS

  validateFullName = () => {
    if (this.state.name.length === 0 || this.state.name.length > 30) {
      this.setState({
        nameError: true,
      });
    } else {
      this.setState({
        nameError: false,
      });
    }
  };

  validateEmail = (isNotOnFocus?: any) => {
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const result = pattern.test(this.state.email);
    if (result === true && this.state.email.length < 150) {
      Axios({
        url: `${apiHost.host}collect-emails`,
        method: 'POST',
        data: {
          email: this.state.email.trim().toLowerCase(),
          failure: false,
          page: `Request Demo Form`,
          url: window.location.href,
        },
      }).catch(() => {
        console.log('Error collecting email');
      });
      if (isNotOnFocus) {
        this.setState({
          emailError: false,
          submitError: false,
          emailErrorText: '',
        });
      } else {
        this.setState({
          emailError: false,
          submitError: false,
          emailErrorText: '',
        });
      }
    } else {
      this.setState({
        emailError: true,
      });
    }
  };

  validateCompany = () => {
    if (this.state.company.length === 0 || this.state.company.length > 30) {
      this.setState({
        companyError: true,
      });
    } else {
      this.setState({
        companyError: false,
      });
    }
  };

  validateContact = () => {
    if (!validatePhone(this.state.contactNumber)) {
      this.setState({
        contactError: true,
        contactFocus: true,
        contactErrorMessage: this.props.messages
          ?.AllFormValidationMessagesValidPhoneNumber,
      });
    } else {
      this.setState({
        contactError: false,
        contactFocus: true,
        contactErrorMessage: '',
      });
    }
  };

  validateDeviceNumber = () => {
    if ((this.state.deviceNumber, 10 <= 0)) {
      this.setState({
        deviceNumberError: true,
      });
    } else {
      this.setState({
        deviceNumberError: false,
      });
    }
  };

  // validateDate = () => {
  //   if (
  //     new Date(this.state.date).setHours(0, 0, 0, 0) >=
  //     new Date().setHours(0, 0, 0, 0)
  //   ) {
  //     this.setState({
  //       preferredDateError: false,
  //     });
  //   } else {
  //     this.setState({
  //       preferredDateError: true,
  //     });
  //   }
  // };

  //   Input Recievers

  handleNameChange = (event: any) =>
    this.setState({ name: event.target.value });
  handleEmailChange = (event: any) =>
    this.setState({ email: event.target.value });
  handleCompanyChange = (event: any) =>
    this.setState({ company: event.target.value });
  handleContactChange = (event: any) =>
    this.setState({ contactNumber: event.target.value });

  handleCountrySelect = (event: any) => {
    this.setState({ defaultCountry: event, countryError: false });
  };
  onKeyPress = (event: any) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (/\+|-/.test(keyValue)) {
      event.preventDefault();
    }
  };

  handleDeviceChange = (event: any) => {
    if (event.target.value) {
      this.setState({
        deviceNumber: event.target.value.replace(/-/g, '').substring(0, 7),
      });
    } else {
      this.setState({ deviceNumber: event.target.value });
    }
  };
  onChangeDate = (event: any) => this.setState({ date: event });

  handleFocusContact = () => this.setState({ contactFocus: true });

  validateContactNumber = () => {
    if (!validatePhone(this.state.contactNumber)) {
      this.setState({
        contactError: true,
        contactFocus: true,
        contactErrorMessage: this.props.messages
          ?.AllFormValidationMessagesValidPhoneNumber,
      });
    } else {
      this.setState({
        contactError: false,
        contactFocus: true,
        contactErrorMessage: '',
      });
    }
  };

  render() {
    return (
      <RequestDemoFormComponent>
        <RequestDemoFormContainer>
          <RequestDemoTitle>
            {this.props.messages?.DemoPageFormTitle}
          </RequestDemoTitle>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="name"
              value={this.state.name}
              aria-label="Full Name"
              backgroundImage={this.state.loaded && FirstNameIcon}
              maxLength={149}
              onChange={this.handleNameChange}
              onBlur={this.validateFullName}
              error={this.state.nameError || this.state.submitError}
              type="text"
              placeholder={this.props.messages?.DemoPageFormName}
              name="Full Name"
            />
            <PasswordMatchError id="name-error">
              {this.state.nameError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid name
                </>
              ) : (
                this.state.nameError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.name.length > 1
                      ? 'Please enter a valid name'
                      : this.props.messages?.AllFormValidationMessagesName}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="email"
              value={this.state.email}
              aria-label="Email"
              backgroundImage={this.state.loaded && EmailIcon}
              maxLength={149}
              onChange={this.handleEmailChange}
              onBlur={this.validateEmail}
              error={this.state.emailError || this.state.submitError}
              type="email"
              placeholder={this.props.messages?.DemoPageFormEmail}
              name="Work Email"
            />
            <PasswordMatchError id="email-error">
              {this.state.emailError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  {this.props.messages?.AllFormValidationMessagesValidEmail}
                </>
              ) : (
                this.state.emailError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.email.length > 1
                      ? this.props.messages?.AllFormValidationMessagesValidEmail
                      : this.props.messages?.AllFormValidationMessagesEmail}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>

          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="company"
              value={this.state.company}
              aria-label="Company"
              backgroundImage={this.state.loaded && CompanyIcon}
              maxLength={149}
              onChange={this.handleCompanyChange}
              onBlur={this.validateCompany}
              error={this.state.companyError || this.state.submitError}
              type="text"
              placeholder={this.props.messages?.DemoPageFormCompany}
              name="Company"
            />
            <PasswordMatchError id="company-error">
              {this.state.companyError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid company name
                </>
              ) : (
                this.state.companyError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.email.length > 1
                      ? 'Please enter a valid company name'
                      : this.props.messages?.AllFormValidationMessagesCompany}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <div
            style={{ display: 'grid' }}
            onMouseDown={this.handleFocusContact}
          >
            <CountrySelect
              value={this.state.defaultCountry}
              onChange={this.handleCountrySelect}
              placeholder="Country"
            />
            <PhoneInput>
              <StyledInputs
                id="contact"
                value={this.state.contactNumber}
                aria-label="Contact"
                style={
                  this.state.contactError
                    ? {
                        boxShadow: '0 0 0 0.1rem #fd7e7ec7',
                        borderRadius: '4px',
                        marginTop: '6px',
                      }
                    : { boxShadow: 'unset', marginTop: '6px' }
                }
                maxLength={149}
                onChange={this.handleContactChange}
                onBlur={this.validateContactNumber}
                onFocus={this.handleFocusContact}
                error={this.state.contactError || this.state.submitError}
                type="text"
                name="contact"
                placeholder={this.props.messages?.DemoPageFormContactNumber}
              />
            </PhoneInput>
            <PasswordMatchError
              style={{ gridColumn: 'span 2' }}
              id="contact-error"
            >
              {this.state.contactError === false && this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  {
                    this.props.messages
                      ?.AllFormValidationMessagesValidPhoneNumber
                  }
                </>
              ) : (
                this.state.contactError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.contactNumber.length > 1
                      ? this.props.messages
                          ?.AllFormValidationMessagesValidPhoneNumber
                      : this.props.messages
                          ?.AllFormValidationMessagesPhoneNumber}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          <div style={{ display: 'grid' }}>
            <StyledInputs
              id="deviceNumber"
              value={this.state.deviceNumber}
              aria-label="deviceNumber"
              min={0}
              max={1000000}
              backgroundImage={this.state.loaded && DeviceNumberIcon}
              onKeyPress={this.onKeyPress}
              onChange={this.handleDeviceChange}
              onBlur={this.validateDeviceNumber}
              error={this.state.deviceNumberError || this.state.submitError}
              type="number"
              placeholder={this.props.messages?.DemoPageFormDevices}
              name="nodevice"
            />
            <PasswordMatchError id="no-devices-error">
              {this.state.deviceNumberError === false &&
              this.state.submitError ? (
                <>
                  <i
                    className="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  />{' '}
                  Please enter a valid number of devices
                </>
              ) : (
                this.state.deviceNumberError && (
                  <>
                    {' '}
                    <i
                      className="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    />{' '}
                    {this.state.deviceNumber.length > 1
                      ? 'Please enter a valid number of devices'
                      : 'Please enter number of devices'}
                  </>
                )
              )}
            </PasswordMatchError>
          </div>
          {this.props.messages?.DemoPageFinePrint1 && (
            <div
              style={{
                display: 'grid',
                maxWidth: '420px',
                justifyContent: 'left',
              }}
            >
              <Checkbox
                label={
                  <div style={{ textAlign: 'left' }}>
                    {this.props.messages?.DemoPageFinePrint1}{' '}
                  </div>
                }
                checked={this.state.consentCheckbox}
                onChange={() =>
                  this.setState(
                    {
                      consentCheckbox: !this.state.consentCheckbox,
                    },
                    () =>
                      this.setState({
                        consentError:
                          this.state.consentError && !this.state.consentCheckbox
                            ? true
                            : false,
                      })
                  )
                }
              />
              <Fade when={this.state.consentError}>
                <PasswordMatchError id="consent-error">
                  {this.state.consentError === true && (
                    <>
                      <i
                        className="fa fa-exclamation-triangle"
                        aria-hidden="true"
                      />{' '}
                      {this.props.messages?.WebsiteConsentErrorValidationText}
                    </>
                  )}
                </PasswordMatchError>
              </Fade>
            </div>
          )}

          <div style={{ display: 'grid' }}>
            <BlueButtonNew id="book_demo__submit" onClick={this.sendData}>
              {this.props.messages?.DemoPageFormSubmitButton}
            </BlueButtonNew>
          </div>

          {this.props?.messages?.WebsiteConsentText2 &&
            this.props.messages.locale !== 'de' && (
              <div style={{ marginTop: '1rem' }}>
                <p
                  style={{
                    fontSize: '14px',
                    fontWeight: 'normal',
                    lineHeight: 'normal',
                    color: '#151828',
                  }}
                >
                  {this.props.messages?.WebsiteConsentText2}{' '}
                  <Link
                    id="terms-of-service"
                    rel="preconnect"
                    to="/terms-of-service/"
                  >
                    {this.props?.messages.WebsiteConsentText3}{' '}
                  </Link>
                  <Link
                    id="terms-of-service"
                    rel="preconnect"
                    to="/privacy-policy/"
                  >
                    {this.props?.messages.WebsiteConsentText4}
                  </Link>
                </p>
              </div>
            )}
        </RequestDemoFormContainer>
      </RequestDemoFormComponent>
    );
  }
}
